import React from 'react';

const ErrorPage = () => {
    return (
        <div>
            <h1>Error Page</h1>
            <p>Oops! Something went wrong.</p>
        </div>
    );
};

export default ErrorPage;